import { UserIdentityProvider, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockMobileDevice } from './mobileDevice';
import { generateMockVisitorGroupMembership } from './visitorGroupMembership';

export function generateMockVisitor({
  id = 'mockVisitorId',
  name = 'mockVisitorName',
  email = null,
  externalRef = null,
  tenantId = 'mockVisitorTenantId',
  mobileDevices = [generateMockMobileDevice({})],
  isEditable = null,
  expirationDate = null,
  visitorGroupMembership = [generateMockVisitorGroupMembership({})],
  identityProvider = UserIdentityProvider.Entra,
  isAdmin = true,
  isQrCodeVisitInviter = true
}: Partial<Omit<Visitor, '__typename'>>): Visitor {
  return {
    __typename: 'Visitor',
    id,
    name,
    email,
    externalRef,
    tenantId,
    mobileDevices,
    isEditable,
    expirationDate,
    visitorGroupMembership,
    identityProvider,
    isAdmin,
    isQrCodeVisitInviter
  };
}
